// extracted by mini-css-extract-plugin
export default {"content":"Container_content__tq0YP"};